import { useMemo } from 'react';
import { Building } from '../../../types/protocols';
import { parkingApi } from '../../../api/parkingApi';
import { storageUnitsApi } from '../../../api/storageUnitsApi';
import { unitsApi } from '../../../api/unitsApi';
import { sortedStorageUnits } from '../../../Helpers/storageUnitUtils';
import { sortedUnits } from '../../../Helpers/unitUtils';
import { naturalCompare } from '../../../Helpers/naturalSort';
import { useFeature } from '../../../hooks/useFeatures';
import { RentableObjects } from './buildingTabsView';

/**
 * The building's parking areas, storage units and units, sorted for display.
 * Features turned off (Inställningar → Funktioner) come back empty, so every
 * card, marker and layer built from these follows the toggles.
 */
export const useRentableObjects = (model: Building['model']): RentableObjects => {
    const parkingEnabled = useFeature('parking');
    const storageEnabled = useFeature('storageUnits');
    const unitsEnabled = useFeature('units');
    return useMemo((): RentableObjects => ({
        parkingAreas: !parkingEnabled ? [] : Object.values(parkingApi.parseAreas(model.parking))
            .sort((a, b) => naturalCompare(a.name || '', b.name || '')),
        storageUnits: !storageEnabled ? [] : sortedStorageUnits(storageUnitsApi.parseUnits(model.storageUnits)),
        units: !unitsEnabled ? [] : sortedUnits(unitsApi.parseUnits(model.units)),
    }), [model, parkingEnabled, storageEnabled, unitsEnabled]);
};
